/**
 * Shared settings for the universal search (top-bar search box and the
 * command palette). Both fire a work order search and an invoice search per
 * debounced keystroke; a one-character term matches most of an account's
 * history and only produces load, so neither searches until the term has
 * this many characters.
 */
export const GLOBAL_SEARCH_MIN_CHARS = 2;

/**
 * What the top-bar search finds, shown in the box and as the folded Search
 * button's text (and name — it starts with "Search", so what is read out
 * matches what is shown): customers by name or phone; work orders by number, RO/PO, VIN or stock number;
 * invoices; and settings, accounts and locations by name.
 */
export const GLOBAL_SEARCH_HINT = 'Search customers, work orders, VIN, stock #, RO/PO, invoices or settings';
/** The same hint where a phone has room for less. */
export const GLOBAL_SEARCH_HINT_SHORT = 'Work order, VIN or invoice';
